import { entity, list } from "./base";
import { concatModules } from "@/utility";
import utility from "@/utility";

const name = "reminders";

const initialEntity = {
  publish_at: null,
  conditions: {},
  title: "",
  body: "",
};

const reminderModule = {
  state: {
    open: false,
    pk: null,
    targets: []
  },
  mutations: {
    open(state, { pk }) {
      state.open = true;
      state.pk = pk;
    },
    close(state) {
      state.open = false;
      state.pk = null;
    },
    fetchedTargets(state, {payload}) {
      state.targets = payload
    }
  },
  actions: {
    targets({ commit, getters }, { }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .get(`/${name}/targets/${getters.pk}`)
          .then((response) => {
            commit("fetchedTargets", {
              payload: response.data.data
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    },
    reminder({ commit }, { id }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .post(`/${name}/reminder/${id}`)
          .then((response) => {
            commit("processed");

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {
    open(state) {
      return state.open;
    },
    pk(state) {
      return state.pk;
    },
    targets(state) {
      return state.targets || [];
    }
  }
};

const entityModule = entity(name, initialEntity);

export const reminders = {
  namespaced: true,
  modules: {
    list: list(name),
    entity: concatModules(entityModule, reminderModule)
  }
};
